module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc9-421465f9a15de894d597452a5607de4f.jpg";